export default {
	apiUrl: "https://api.rajitblog.com"
};



// WEBPACK FOOTER //
// ./src/config/index.js